const LOCALE_PREFIX = /^\/[a-z]{2}-[a-z]{2}(?=\/|$)/i;
const SPRITE_ELEMENT_ID = 'global-svg-sprite';
const SPRITE_URL = 'assets/svg/sprite.svg';

let spritePromise = null;

function ensureSpriteInjected() {
  if (document.getElementById(SPRITE_ELEMENT_ID)) {
    return Promise.resolve();
  }
  if (!spritePromise) {
    spritePromise = fetch(SPRITE_URL)
      .then((response) => {
        if (!response.ok) throw new Error('Failed to load SVG sprite');
        return response.text();
      })
      .then((markup) => {
        const container = document.createElement('div');
        container.style.position = 'absolute';
        container.style.width = '0';
        container.style.height = '0';
        container.style.overflow = 'hidden';
        container.innerHTML = markup.trim();
        const svg = container.querySelector('svg');
        if (svg) {
          svg.style.position = 'absolute';
          svg.style.width = '0';
          svg.style.height = '0';
          svg.style.overflow = 'hidden';
          svg.id = SPRITE_ELEMENT_ID;
          document.body.insertBefore(svg, document.body.firstChild);
        }
      })
      .catch(() => {});
  }
  return spritePromise;
}


// Normalize to project-root file name only (works under subpaths and file://)
function normalizePath(pathname) {
  if (!pathname) return '/index.html';
  // strip query/hash
  let raw = String(pathname).split('?')[0].split('#')[0];
  // Optional locale prefix (at root level)
  if (LOCALE_PREFIX.test(raw)) {
    raw = raw.replace(LOCALE_PREFIX, '') || '/';
  }
  // Treat trailing slash as index.html
  if (raw === '/' || raw === '') return '/index.html';
  raw = raw.replace(/\/+$/, '');
  const last = raw.split('/').pop() || 'index.html';
  let filename = last;
  if (!/\.html$/i.test(filename)) {
    // Map directories or bare names to index.html or name.html as fallback
    filename = filename === '' ? 'index.html' : `${filename}.html`;
  }
  filename = filename.toLowerCase();
  return `/${filename}`;
}

// 保留此函数以备将来使用
// function normalizeHref(href) {
//   try {
//     // Resolve against the current URL to preserve subpath or file:// directories
//     const url = new URL(href, window.location.href);
//     if (url.origin !== window.location.origin) return null; // external
//     return normalizePath(url.pathname);
//   } catch (_err) {
//     return null;
//   }
// }

function highlightActiveNav() {
  const current = normalizePath(window.location.pathname);
  const currentHash = window.location.hash || '';
  const anchors = document.querySelectorAll('.nav-links a, #mobileNavMenu a, .nav-dropdown__item');
  const resourcesParent = document.querySelector('.nav-link--dropdown');
  let hasActiveDropdownItem = false;
  
  anchors.forEach((anchor) => {
    const href = anchor.getAttribute('href');
    
    // 跳过下拉菜单的触发链接（href="#"）
    if (href === '#') {
      return;
    }
    
    let url;
    try {
      url = new URL(href, window.location.href);
    } catch {
      anchor.classList.remove('is-active');
      return;
    }
    if (url.origin !== window.location.origin) {
      anchor.classList.remove('is-active');
      return;
    }

    const samePath = normalizePath(url.pathname) === current;
    const wantsHash = !!url.hash;

    // If the link targets a specific hash, require matching hash as well
    const shouldActive = wantsHash ? samePath && (url.hash === currentHash) : samePath;
    anchor.classList.toggle('is-active', shouldActive);
    
    // 检查是否有子菜单项被激活
    // 包括桌面端的 nav-dropdown__item 和移动端 Resources 子菜单中的链接
    const isDropdownItem = anchor.classList.contains('nav-dropdown__item') || 
                          anchor.closest('.nav-menu__page--resources') !== null;
    if (shouldActive && isDropdownItem) {
      hasActiveDropdownItem = true;
    }
  });
  
  // 如果子菜单项被激活，同时激活父级Resources
  if (hasActiveDropdownItem && resourcesParent) {
    resourcesParent.classList.add('is-active');
  } else if (resourcesParent && !hasActiveDropdownItem) {
    // 如果没有子菜单项激活，检查Resources本身是否应该激活
    const resourcesHref = resourcesParent.getAttribute('href');
    if (resourcesHref === '#') {
      resourcesParent.classList.remove('is-active');
    }
  }
}

export function setupNavigation() {
  ensureSpriteInjected();
  const navMenu = document.getElementById('mobileNavMenu');
  const navToggle = document.querySelector('.nav-toggle');
  const navMenuClose = document.querySelector('.nav-menu__close');
  const navMenuBackdrop = document.querySelector('.nav-menu__backdrop');
  const bodyEl = document.body;

  // 阻止Resources链接的点击事件（PC端）
  const resourcesLink = document.querySelector('.nav-link--dropdown');
  if (resourcesLink) {
    resourcesLink.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      return false;
    });
  }

  if (!navToggle || !navMenu) {
    highlightActiveNav();
    return;
  }

  let unlockTimer = null;

  const openMenu = () => {
    if (unlockTimer) {
      clearTimeout(unlockTimer);
      unlockTimer = null;
    }
    navMenu.classList.remove('show-resources'); // 确保打开时显示主菜单
    navMenu.classList.add('active');
    navMenu.setAttribute('aria-hidden', 'false');
    if (navMenuBackdrop) {
      navMenuBackdrop.classList.add('active');
      navMenuBackdrop.setAttribute('aria-hidden', 'false');
    }
    navToggle.classList.add('is-active');
    navToggle.setAttribute('aria-expanded', 'true');
    bodyEl.classList.add('no-scroll');
  };

  const closeMenu = (force = false) => {
    navMenu.classList.remove('active');
    navMenu.classList.remove('show-resources'); // 重置到主菜单页面
    navMenu.setAttribute('aria-hidden', 'true');
    if (navMenuBackdrop) {
      navMenuBackdrop.classList.remove('active');
      navMenuBackdrop.setAttribute('aria-hidden', 'true');
    }
    navToggle.classList.remove('is-active');
    navToggle.setAttribute('aria-expanded', 'false');
    if (unlockTimer) {
      clearTimeout(unlockTimer);
      unlockTimer = null;
    }
    if (force) {
      bodyEl.classList.remove('no-scroll');
    } else {
      unlockTimer = window.setTimeout(() => {
        bodyEl.classList.remove('no-scroll');
        unlockTimer = null;
      }, 300);
    }
  };

  navToggle.addEventListener('click', (event) => {
    event.stopPropagation();
    if (navMenu.classList.contains('active')) {
      closeMenu();
    } else {
      openMenu();
    }
  });

  // 关闭按钮点击事件
  if (navMenuClose) {
    navMenuClose.addEventListener('click', (event) => {
      event.stopPropagation();
      closeMenu();
    });
  }

  // 背景遮罩点击关闭菜单
  if (navMenuBackdrop) {
    navMenuBackdrop.addEventListener('click', (event) => {
      event.stopPropagation();
      closeMenu();
    });
  }

  // 移动端 Resources 子菜单页面切换
  const mobileResourcesLink = navMenu?.querySelector('.nav-menu__page--main .nav-link--dropdown');
  const navMenuBack = navMenu?.querySelector('.nav-menu__back');
  
  // 点击 Resources 链接，向右滑出子菜单页面
  if (mobileResourcesLink) {
    mobileResourcesLink.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      navMenu.classList.add('show-resources');
    });
  }
  
  // 点击 Back 按钮，向右滑出回到主菜单
  if (navMenuBack) {
    navMenuBack.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      navMenu.classList.remove('show-resources');
    });
  }

  // Remove outside-click and backdrop-click closing per requirement
  // (Only nav links and the toggle 'X' should close the menu)

  // Ensure mobile menu links navigate reliably on all stacks (event delegation)
  const handleMenuLink = (event) => {
    const anchor = event.target.closest('a');
    if (!anchor || !navMenu.contains(anchor)) return;

    // 跳过 Resources 链接（由专门的处理器处理）
    if (anchor.classList.contains('nav-link--dropdown')) {
      return;
    }

    const href = anchor.getAttribute('href');
    if (!href || href === '#') {
      closeMenu();
      return;
    }

    // Respect explicit new-tab requests
    const targetAttr = anchor.getAttribute('target');
    if (targetAttr === '_blank') {
      closeMenu();
      return; // allow default
    }

    // Build absolute URL
    let url;
    try {
      url = new URL(href, window.location.href);
    } catch {
      closeMenu();
      return;
    }

    // External: just close and allow default
    if (url.origin !== window.location.origin) {
      closeMenu();
      return;
    }

    const currentPath = normalizePath(window.location.pathname);
    const targetPath = normalizePath(url.pathname);

    // Same page + hash: smooth scroll rather than full reload
    if (targetPath === currentPath && url.hash) {
      const id = decodeURIComponent(url.hash.slice(1));
      const el = document.getElementById(id);
      if (el) {
        event.preventDefault();
        // Close menu instantly to avoid visible upward slide before scroll
        const prevTransition = navMenu.style.transition;
        navMenu.style.transition = 'none';
        closeMenu(true);
        requestAnimationFrame(() => {
          navMenu.style.transition = prevTransition || '';
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          history.pushState(null, '', `#${id}`);
        });
        return;
      }
    }

    // Cross-page navigation: navigate immediately without closing animation
    // to prevent the menu from sliding upward before unload.
    if (targetPath !== currentPath) {
      event.preventDefault();
      window.location.assign(url.href);
      return;
    }

    // Fallback: same page without hash
    event.preventDefault();
    window.location.assign(url.href);
  };

  navMenu.addEventListener('click', handleMenuLink, { capture: false });

  // Remove ESC-to-close; keep only explicit actions (links or toggle)

  window.addEventListener('resize', () => {
    if (window.innerWidth >= 769) {
      closeMenu(true);
    }
  });

  highlightActiveNav();
  window.addEventListener('hashchange', highlightActiveNav);
  window.addEventListener('popstate', highlightActiveNav);
}

export function refreshActiveNav() {
  highlightActiveNav();
}
